import lodash from 'lodash';
import { isSetter } from '../utils/guards.js';
const { isEqual } = lodash;
const dedupe = (atom) => {
    const set = (value) => {
        if (value === undefined)
            return atom.reset();
        return atom.set(async (previous) => {
            const newValue = isSetter(value) ? await value(previous) : value;
            return isEqual(previous, newValue) ? previous : newValue;
        });
    };
    const observe = (callback) => {
        let called = false;
        let previous;
        return atom.observe(async (value) => {
            if (called && isEqual(previous, value))
                return;
            called = true;
            previous = value;
            return callback(value);
        });
    };
    return {
        ...atom,
        set,
        observe,
    };
};
export default dedupe;
